import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-download-template-modal',
  standalone: true,
  imports: [TranslocoDirective, TranslocoPipe],
  templateUrl: './download-template-modal.component.html',
  styleUrl: './download-template-modal.component.scss'
})
export class DownloadTemplateModalComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() imageSrc = '';
  @Input() imageAlt = '';

  private activeModal = inject(NgbActiveModal);

  close(): void {
    this.activeModal.dismiss();
  }

  download(): void {
    this.activeModal.close('download');
  }
}
